import { createSlice } from "@reduxjs/toolkit";
import { ICareerState } from "./careerModel";
import { getCareerDetails, updateCareer } from "./services/career.services";

const initialState: ICareerState = {
  loading: false,
  error: "",
  CareerImageID: null,
  CareerDetails: {
    BannerImage: "",
    Description: "",
  },
};

const careerSlice = createSlice({
  name: "career",
  initialState,
  reducers: {
    clearCareerDetails: (state) => {
      state.CareerDetails = initialState.CareerDetails;
    },
    setCareerImageID: (state, action) => {
      state.CareerImageID = action.payload;
    },
    clearCareerImageID: (state) => {
      state.CareerImageID = initialState.CareerImageID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateCareer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateCareer.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCareer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCareerDetails.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getCareerDetails.fulfilled, (state, action: any) => {
      state.loading = false;
      state.CareerDetails = action.payload;
    });
    builder.addCase(getCareerDetails.rejected, (state, action) => {
      state.loading = false;
      state.CareerDetails = initialState.CareerDetails;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const { clearCareerDetails, setCareerImageID, clearCareerImageID } =
  careerSlice.actions;
export default careerSlice.reducer;
